import { makeStyles } from "@material-ui/core/styles";
import { fontWeight, padding } from "@mui/system";

export default makeStyles({
  searchbar: {
    display: "flex",
    flexDirection: "column",
    padding: 50,
    alignItems: "start",
    ["@media (max-width:1200px)"]: {
      padding: 40,
    },
    ["@media (max-width:959px)"]: {
      padding: 20,
    },
    ["@media (max-width:559px)"]: {
      padding: 5,
      paddingTop: 20,
    },
  },
  box: {
    display: "flex",
    flexDirection: "column",
    paddingTop: 30,
    width: "100%",
    ["@media (max-width:959px)"]: {
      paddingTop: 10,
      alignItems: "center",
    },
  },
  formFeild: {
    border: "none",
    height: 40,
    marginTop: 15,
    marginBottom: 20,
    padding: 10,
    paddingLeft: 16,
    color: "#547972",
    fontSize: 16,
    width: "80%",
    background: "#fefff0",
    borderRadius: 5,
    outline: "none",
    ["@media (max-width:559px)"]: {
      width: "86%",
    },
  },
  submitBtn: {
    border: "none",
    height: 40,
    marginTop: 15,
    marginBottom: 20,
    padding: 10,
    paddingLeft: 16,
    color: "#547972",
    fontSize: 16,
    width: "80%",
    background: "#fefff0",
    borderRadius: 5,
    outline: "none",

    "&:hover": {
      background: "#eaebdc",
    },
    ["@media (max-width:559px)"]: {
      width: "86%",
    },
  },
});
